/* ==========================================================================
   CalendarRxjs > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    active: false,
    disabled: false,
    hidden: false,
    error: false,
    valid: false,
    mode: null,
    value: null
};

/* Reducer */
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.DESTROY:
            return null;
        case types.DISABLE:
            return {
                ...state,
                disabled: true
            };
        case types.DISPLAY:
            return {
                ...state,
                hidden: false
            };
        case types.ENABLE:
            return {
                ...state,
                disabled: false
            };
        case types.HIDE:
            return {
                ...state,
                hidden: true
            };
        case types.RESET_STATUS:
            return {
                ...state,
                error: false,
                valid: false
            };
        case types.SET_ERROR:
            return {
                ...state,
                error: true,
                valid: false
            };
        case types.SET_MODE:
            return {
                ...state,
                mode: action.payload,
                value: state.value
                    ? state.value.filter((item, index) => {
                          if (index < 1) {
                              return true;
                          }

                          if (action.payload.toLowerCase() !== 'range') {
                              return false;
                          }

                          return true;
                      })
                    : state.value
            };
        case types.SET_VALID:
            return {
                ...state,
                error: false,
                valid: true
            };
        case types.TOGGLE_ACTIVE:
            return {
                ...state,
                active: !state.active
            };
        case types.SET_VALUE:
        case types.CHANGE_VALUE:
            return {
                ...state,
                value: action.payload
            };
        default:
            return state;
    }
}

/* Exports */
module.exports = {
    reducer
};
